import lamejs from 'lamejs';
import {ElMessage} from "element-plus";
import clipboard3 from "vue-clipboard3";

let roleUtil = {

    getAllMatchPeople:function (peopleList,keyWord){
        if (keyWord===""){
            return []
        }
        let ret = []
        let length = peopleList.length
        for (let i = 0; i <length ; i++) {
            if (peopleList[i].userCount.indexOf(keyWord)+peopleList[i].nickName.indexOf(keyWord) !== -2){
                ret.push(peopleList[i])
            }
        }
        return ret
    },
    getActualIndex:function (roleList,userCount){
        for (let i = 0; i < roleList.length ; i++) {
            if (roleList[i].userCount === userCount){
                return i;
            }

        }

    },
    showElMessage:function (resp){
        let type
        type = resp.data.code===200?'success':'error'
          ElMessage({
              showClose: true,
              message: resp.data.data,
              type: type,
          })
    },
    showMsg(msg){
        ElMessage({
            showClose: true,
            message: msg,
            type: 'success',
        })
    },
    async paste(msg) {
        const {toClipboard} =  clipboard3();
        try {
            await toClipboard(msg);
            this.showMsg("复制成功")
        } catch (error) {
            alert(error + "复制失败!!")
        }
    },
    showErrorMsg(msg){
        ElMessage({
            showClose: true,
            message: msg,
            type: 'error',
        })
    },
    checkResp:function (resp){
        if (resp.data.code !== 200){
            ElMessage({
                showClose: true,
                message: resp.data.data,
                type: 'error',
            })
            return false
        }
        return true
    },
    changeLineStatus:function (userCount,status,_this){
        let a = [];
        for (let i = 0; i < _this.groupInfo.roleList.length; i++) {
            if (_this.groupInfo.roleList[i].userCount === userCount){
                _this.groupInfo.roleList[i].online = status
                _this.groupInfo.roleList.sort(function (b,a){
                    if (a.userLevel === "0"){
                        return 1;
                    }
                    if (b.userLevel === "0"){
                        return -1;
                    }

                    if (a.userLevel === "1" && a.online === "1"){
                        return 1;
                    }

                    if (b.userLevel === "1" && b.online === "1"){
                        return -1;
                    }

                    if (a.userLevel === "1" && a.online === "0"){
                        return 1;
                    }

                    if (b.userLevel === "1" && b.online === "0"){
                        return -1;
                    }
                    if (a.online === "1"){
                        return 1;
                    }
                    if (b.online === "1"){
                        return -1;
                    }

                    if (a.online === "0"){
                        return 1;
                    }
                    if (b.online === "0"){
                        return -1;
                    }
                    return 1;
                })
                return i

            }
        }
    },
    searchBoxInfo:function (userMessage,userList,groupInfo,keyWord){
        let ret = []
        if (keyWord === null || keyWord===""){
            return ret
        }
        for (let i = 0; i < userMessage.length; i++) {
            if (userMessage[i].msg.indexOf(keyWord)!==-1){
                let param = {
                    userCount:userMessage[i].sendId,
                    nickName:userMessage[i].sendNickName,
                    photo:userMessage[i].countPhoto,
                    sendMsg:userMessage[i].msg,
                    type:userMessage[i].countType
                }
                ret.push(param)
            }
        }

        for (let i = 0; i < userList.length; i++) {
            for (let j = 0; j < userList[i].userCount.length; j++) {
                if (userList[i].userCount[j].userCount.userCount.indexOf(keyWord)!==-1||userList[i].userCount[j].userCount.nickName.indexOf(keyWord)!==-1){
                    let param = {
                        userCount:userList[i].userCount[j].userCount.userCount,
                        nickName:userList[i].userCount[j].userCount.nickName,
                        photo:userList[i].userCount[j].userCount.photo,
                        sendMsg:"点击开始聊天",
                        type:'0'
                    }
                    ret.push(param)
                }

            }

        }


        for (let i = 0; i < groupInfo.length; i++) {
            for (let j = 0; j < groupInfo[i].groupCount.length; j++) {
                if (groupInfo[i].groupCount[j].groupCount.indexOf(keyWord)!==-1||groupInfo[i].groupCount[j].groupName.indexOf(keyWord)!==-1){
                    let param = {
                        userCount:groupInfo[i].groupCount[j].groupCount,
                        nickName:groupInfo[i].groupCount[j].groupName,
                        photo:groupInfo[i].groupCount[j].photo,
                        sendMsg:"点击开始聊天",
                        type:'1'
                    }
                    ret.push(param)
                }
            }
        }


        let obj ={}
         ret.forEach((item)=>{obj[item.userCount+"a"+item.type] = item})
         let a = []
        for (let key in obj) {
            a.push(obj[key])
        }
          return a


    },
    leaveOut:function (_this,message){
        _this.$axios.post('/lightChat/login/outLine',"",_this.$roleUtil.fillHeader()).then(resp=>{
            if (message != null && resp.data.code === 200){
                _this.$elMeassage({
                    showClose: true,
                    message: resp.data.data,
                    type: 'success',
                })
            }
        })
        if (_this.ws != null){
            _this.ws.close()
        }
        sessionStorage.setItem("authorization",null)
        _this.$store.commit('changeWs',null)
        _this.$roleUtil.changeRouter('login','lightChatHome','login',_this)
    },
    changeRouter:function (newRouter,nowRouter,defaultRouter,_this){
        let aimRouter = this.getAimRouter(newRouter,nowRouter,defaultRouter,_this)
        if (aimRouter !== undefined){
            sessionStorage.setItem("lastPath",nowRouter)
            if (newRouter!==null){
                if (newRouter.includes('?')){
                    _this.$router.push(newRouter)
                    return 0
                }
                _this.$router.push(aimRouter).then( r =>{})
            }else {
                _this.$router.push(aimRouter).then( r =>{})
            }
        }

    },
    getAimRouter:function (newRouter,nowRouter,defaultRouter,_this){
        let aimRouter = newRouter
        if (aimRouter === undefined||aimRouter===null||aimRouter===''){
            let sessionRouter = sessionStorage.getItem("lastPath")
            if (aimRouter !==''&&nowRouter !== sessionRouter){              //防止两个页面死循环
                aimRouter = sessionRouter
            }
        }
        if (aimRouter === undefined||aimRouter===null||aimRouter===''){
            aimRouter = defaultRouter
        }
        return aimRouter
    },
    changeRouterParam:function (newRouter,nowRouter,defaultRouter,_this,param){
        let aimRouter = this.getAimRouter(newRouter,nowRouter,defaultRouter,_this)
        if (aimRouter !== undefined){
            sessionStorage.setItem("lastPath",nowRouter)
            _this.$router.push({name: aimRouter, params: {lastPath: nowRouter,param:param}}).then( r =>{})
        }
    },
    loadingCarton:function (obj){
        let k = 0;
        let interval = setInterval(()=>{
            k = k + 1;
            obj.style.transform = 'rotate('+k+'deg)'
        },10)
       return interval
    },
    fillHeader:function (){
        return {
        headers: {'authorization': sessionStorage.getItem("authorization")}
    }
},
    convertToMp3:function (wavDataView,recorder)
    {
        // 获取wav头信息
        const wav = lamejs.WavHeader.readHeader(wavDataView); // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
        const {channels, sampleRate} = wav;
        const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
        // 获取左右通道数据
        const result = recorder.getChannelData()
        const buffer = [];

        const leftData = result.left && new Int16Array(result.left.buffer, 0, result.left.byteLength / 2);
        const rightData = result.right && new Int16Array(result.right.buffer, 0, result.right.byteLength / 2);
        const remaining = leftData.length + (rightData ? rightData.length : 0);

        const maxSamples = 1152;
        for (let i = 0; i < remaining; i += maxSamples) {
            const left = leftData.subarray(i, i + maxSamples);
            let right = null;
            let mp3buf = null;

            if (channels === 2) {
                right = rightData.subarray(i, i + maxSamples);
                mp3buf = mp3enc.encodeBuffer(left, right);
            } else {
                mp3buf = mp3enc.encodeBuffer(left);
            }

            if (mp3buf.length > 0) {
                buffer.push(mp3buf);
            }
        }

        const enc = mp3enc.flush();

        if (enc.length > 0) {
            buffer.push(enc);
        }

        return new Blob(buffer, {type: 'audio/mp3'});

    },
    sendMsgToSpringAndWs:function (_this,file,param,url,userInfo,type,viaGroup){
        let formData = new FormData()
        let bsId = new Date() + "-" + param.sendId + "-" + Math.floor(Math.random() * 10);
        formData.append("file",file.raw)
        formData.append('defaultInfo', JSON.stringify(param))
        formData.append('bsId', bsId)
        if (viaGroup != null){
            formData.append('viaGroup', viaGroup)
        }
        let talkMessage = {
            sendId: userInfo.userCount,
            sendPhoto: userInfo.photo,
            msg: "",
            fileName: file.name,
            type: "-1",
        }
        if (type === '0') {
            _this.groupInfo.groupMsg.push(talkMessage)
            _this.groupInfo.sendIndex = _this.groupInfo.groupMsg.length - 1;
        }
        if (type === '1') {
            _this.talkBox.talkMessage.push(talkMessage)
            _this.talkBox.sendIndex = _this.talkBox.talkMessage.length - 1
        }
            _this.$axios.post(url, formData, _this.$roleUtil.fillHeader()).then(resp => {
                if (resp.data.code !== 200){
                    this.showElMessage(resp)
                }
               
                    // if (type === '0'){
                    //     _this.groupInfo.groupMsg.splice(_this.groupInfo.sendIndex,1)
                    // }
                    //
                    // if (type === '1'){
                    //     let a = _this.talkBox.talkMessage
                    //     _this.talkBox.talkMessage.splice(_this.talkBox.sendIndex,1)
                    // }
                let temp = [];
                if (type === '0'){
                    _this.groupInfo.groupMsg.forEach(t=>{
                        if (t.type !== "-1"){
                            temp.push(t)
                        }
                      })
                    _this.groupInfo.groupMsg = temp
                }

                if (type === '1'){
                    _this.talkBox.talkMessage.forEach(t=>{if (t.type !== "-1"){
                            temp.push(t)
                    }})
                    _this.talkBox.talkMessage = temp
                }
                _this.messageSend.count--;
                if (_this.messageSend.count <= 0){
                    _this.loadingBody = false
                }

        })
    },
    getType:function (fileName){
        if (/\.(png|jpg|gif|jpeg|webp)$/.test(fileName)) {
            return  "2"
        }
        if (/\.(mp4|avi|wmv|asf|)$/.test(fileName)) {
            return  "3"
        }
        if (/\.(mpeg|mp3|wma|midi|)$/.test(fileName)) {
            return  "4"
        }
        return "5"
    },
    homeGetNewMessage:function (talkMsg,data,msgType){
        let newMsg = {
            sendNickName:data.sendNickName,
            sendId:data.sendId,
            countPhoto:data.countPhoto,
            showTime:this.getDate(),
            countType:msgType,
            type:data.msgType
        }
        let msg = data.msg
        if (data.type === '0'){
            msg = newMsg.sendNickName+" :"+msg
        }
        if (data.type === '1'){
             msg = newMsg.sendNickName+" :[语音消息]"
        }
        if (data.type === '2'){
             msg = newMsg.sendNickName+" :[图片]"
        }
        if (data.type === '3'){
             msg = newMsg.sendNickName+" :[视频消息]"
        }
        if (data.type === '4'){
             msg = newMsg.sendNickName+" :[语音消息]"
        }
        if (data.type === '5'){
             msg = newMsg.sendNickName+" :[文件消息]"
        }
        if (data.msgType === '1'){
            newMsg.sendNickName = data.groupNickName
        }
         newMsg.msg = msg
        let hasPut = false
        for (let i = 0; i < talkMsg.length; i++) {
            if (talkMsg[i].countType === msgType && talkMsg[i].sendId === newMsg.sendId){
                if (talkMsg[i].unRead == null){
                    newMsg.unRead = 1
                }else {
                    newMsg.unRead = talkMsg[i].unRead + 1
                }
                talkMsg.splice(i,1)
                talkMsg.unshift(newMsg)
                hasPut = true
                break
            }
        }
        if (!hasPut){
        newMsg.unRead = 1
        talkMsg.unshift(newMsg)
        }

    },
    getDate:function (){
        let date = new Date();
        let time = date.getHours()>9?date.getHours():"0"+date.getHours()
        let minutes = date.getMinutes()>9?date.getMinutes():"0"+date.getMinutes()
        return time + ":" + minutes
    },
    checkLoginStatus:function (_this){
        let authorization = sessionStorage.getItem("authorization")
        if (authorization == null){
            _this.$router.push('/login').then(r => {
                _this.$elMeassage({
                    showClose: true,
                    message: "你还未登陆，请先登录",
                    type: 'success',
                })
            })
            return false
        }

        return true
    },
    formatDate(date,format){
        let theCurrentDate;
        //判断类型决定是否新生成时间
        if (typeof date === Date){
            theCurrentDate = date
        }{
            theCurrentDate  = new Date(date)
        }
        if (!format || format === '' ){
            format = 'yyyy-MM-dd HH:mm:ss'
        }
        //获取年份
        let year = (theCurrentDate.getFullYear()).toString();
        format = format.replace('yyyy', year);
        format = format.replace('yy', year.slice(year.length-2,year.length));
        //获取月份
        let month = (theCurrentDate.getMonth() + 1).toString();
        format = format.replace('MM', month.length === 2?month:'0'+month);
        format = format.replace('M', month);
        //获取天数
        let day = (theCurrentDate.getDate()).toString();
        format = format.replace('dd', day.length === 2?day:'0'+day);
        format = format.replace('d',day);
        //获取24小时制时间
        let hour = (theCurrentDate.getHours()).toString();
        format = format.replace('HH', hour.length === 2?hour:'0'+hour);
        format = format.replace('H', hour);
        //获取12小时制
        let twelveHour = (theCurrentDate.getHours() % 12).toString();
        format = format.replace('hh', twelveHour.length === 2?twelveHour:'0'+twelveHour);
        format = format.replace('h', twelveHour);
        //获取分钟
        let minutes = (theCurrentDate.getMinutes()).toString();
        format = format.replace('mm', minutes.length === 2?minutes:'0'+minutes);
        format = format.replace('m',minutes);
        //获取秒数
        let second = (theCurrentDate.getSeconds()).toString();
        format = format.replace('ss', second.length === 2?second:'0'+second);
        format = format.replace('s',second);
        //获取星期
        let  week = (theCurrentDate.getDay()).toString();
        //将星期由数字转为中文
        let weekDic = ['日', '一', '二', '三', '四', '五', '六']
        format = format.replace('w',weekDic[week]);
        return format;
    },


}

export default roleUtil
